import { ValueChangeEvent } from '@angular/forms'

export const conflictRelated = [
    { value: 'CONFLICTO ARMADO' },
    { value: 'CONFLICTO SOCIAL' },
]

export const violence = [
    { value: 'DIGITAL' },
    { value: 'ECONOMICA' },
    { value: 'FISICA' },
    { value: 'PATRIMONIAL' },
    { value: 'PSICOLOGICA O EMOCIONAL' },
    { value: 'POLITICA' },
    { value: 'SEXUAL' },
    { value: 'SIMBOLICA' },
    { value: 'OBSTETRICA' },
    { value: 'VICARIA' },
]

export const typePerson = [
    { value: 'GRUPO ARMADO' },
    { value: 'GRUPO SOCIAL O COMUNITARIO' },
    { value: 'JURIDICA' },
    { value: 'NATURAL' },
    { value: 'OTRO' },
]

export const identificationTypes = [
    { value: 'CC', label: 'Cedula de ciudadanía' },
    { value: 'CE', label: 'Cedula de extranjería' },
    { value: 'NIT', label: 'Registro único tributario' },
    { value: 'PE', label: 'Pasaporte' },
    { value: 'RC', label: 'Registro civil' },
    { value: 'TI', label: 'Tarjeta de identidad' },
    { value: 'OTRO', label: 'Otro' },
]

export const sex = [
    { value: 'M', label: 'MASCULINO' },
    { value: 'F', label: 'FEMENINO' },
]

export const civilStatus = [
    { value: 'CASADO(A)' },
    { value: 'DIVORCIADO(A)' },
    { value: 'SOLTERO(A)' },
    { value: 'UNION LIBRE' },
    { value: 'OTRO' },
]

export const sexualOrientation = [
    { value: 'ASEXUAL' },
    { value: 'BISEXUAL' },
    { value: 'HETERO SEXUAL' },
    { value: 'HOMOSEXUAL' },
    { value: 'PANSEXUAL' },
    { value: 'NO BINARIO' },
    { value: 'OTRO' },
    { value: 'PREFIERO NO DECIRLO' },
]

export const educationLevel = [
    { value: 'PRIMARIA' },
    { value: 'PRIMARIA INCOMPLETA' },
    { value: 'SECUNDARIA' },
    { value: 'SECUNDARIA INCOMPLETA' },
    { value: 'TECNICA' },
    { value: 'TECNOLOGIA' },
    { value: 'UNIVERSITARIA' },
    { value: 'POSGRADO' },
    { value: 'NINGUNA' },
    { value: 'SIN INFORMACION' },
]

export const lengueageProperty = [
    { value: 'HyE', label: 'Lo habla y lo escribe' },
    { value: 'HnE', label: 'Lo habla pero no lo escribe' },
    { value: 'EnH', label: 'No lo habla pero lo escribe' },
    { value: 'nHnE', label: 'No lo habla ni lo escribe' },
    { value: 'N/A', label: 'No sabe' },
    { value: 'SIN INFO', label: 'Sin información' },
]

export const occupation = [
    { value: 'AMA DE CASA' },
    { value: 'AGRICULTOR' },
    { value: 'AGRICULTORA' },
    { value: 'COMUNERO' },
    { value: 'COMUNERA' },
    { value: 'DESEMPLEADO' },
    { value: 'DESEMPLEADA' },
    { value: 'DINAMIZADOR' },
    { value: 'DINAMIZADORA' },
    { value: 'ESTUDIANTE' },
    { value: 'EMPLEADO' },
    { value: 'EMPLEADA' },
    { value: 'INDEPENDIENTE' },
    { value: 'PENSIONADO' },
    { value: 'PENSIONADA' },
    { value: 'OTRO' },
]

export const sourceIncome = [
    { value: 'AGRICULTURA' },
    { value: 'DEPENDE ECONOMICAMENTE DE ALGUIEN' },
    { value: 'DINAMIZADORA COMUNITARIA' },
    { value: 'EMPLEO FORMAL' },
    { value: 'OFICIOS VARIOS' },
    { value: 'PRESTACION DE SERVICIOS' },
    { value: 'SIN INFORMACION' },
]

export const leadertype = [
    { value: 'LIDER SOCIAL', label: 'SOCIAL' },
    { value: 'LIDER COMUNITARIO', label: 'COMUNITARIO' },
    { value: 'LIDER POLITICO', label: 'POLITICO' },
    { value: 'LIDER EMPRESARIAL', label: 'EMPRESARIAL' },
    { value: 'LIDER RELIGIOSO', label: 'RELIGIOSO' },
    { value: 'LIDER ACADEMICO', label: 'ACADEMICO' },
    { value: 'LIDER INDIGENA', label: 'INDIGENA' },
    { value: 'LIDER AMBIENTAL', label: 'AMBIENTAL' },
    { value: 'LIDER SINDICAL', label: 'SINDICAL' },
    { value: 'LIDER JUVENIL', label: 'JUVENIL' },
    { value: 'LIDER TRANSFORMACIONAL', label: 'TRANSFORMACIONAL' },
    { value: 'LIDER TECNICO', label: 'TECNICO' },
    { value: 'LIDER DE DERECHOS HUMANOS', label: 'DERECHOS HUMANOS' },
    { value: 'LIDER DE GENERO', label: 'GENERO' },
    { value: 'LIDER DE PAZ', label: 'PAZ' },
    { value: 'LIDER CULTURAL', label: 'CULTURAL' },
    { value: 'LIDER DE SALUD', label: 'SALUD' },
    { value: 'LIDER DE EDUCACION', label: 'EDUCACION' },
    { value: 'LIDER DE DESARROLLO SOCIAL', label: 'DESARROLLO SOCIAL' },
    { value: 'AUTORIDAD ANCESTRAL', label: 'AUTORIDAD ANCESTRAL' },
    { value: 'DINAMIZADORA COMUNITARIA', label: 'DINAMIZADORA COMUNITARIA' },
    {
        value: 'LIDERAZGO COMUNITARIO Y DEFENSORA DE DD HH',
        label: 'LIDERAZGO COMUNITARIO Y DEFENSORA DE DD HH',
    },
    { value: 'KIWE THEGNAS', label: 'KIWE THEGNAS' },
    { value: 'PRESIDENTA JAC', label: 'PRESIDENTA JAC' },
    { value: 'NO APLICA', label: 'NO APLICA' },
]

export const disabilityTypes = [
    { value: 'AUDITIVA' },
    { value: 'FISICA' },
    { value: 'INTELECTUAL' },
    { value: 'MULTIPLE' },
    { value: 'PSICOSOCIAL' },
    { value: 'SENSORIAL' },
    { value: 'VISUAL' },
    { value: 'NINGUNA' },
]

export const whoReports = [
    { value: 'AUTORIDAD DEL TERRITORIO' },
    { value: 'AMIGO(A)' },
    { value: 'ANONIMO' },
    { value: 'COORDINACION LOCAL' },
    { value: 'COMUNERO' },
    { value: 'COMISARIA DE FAMILIA' },
    { value: 'DOCENTE' },
    { value: 'FAMILIAR' },
    { value: 'GUARDIA' },
    { value: 'MEDIO DE COMUNICACION' },
    { value: 'ORGANIZACION' },
    { value: 'PERSONERIA' },
    { value: 'VICTIMA DIRECTA' },
    { value: 'OTRO' },
]

export const ethnic = [
    { value: 'AFROCOLOMBIANO' },
    { value: 'CAMPESINO' },
    { value: 'GITANOS O ROM' },
    { value: 'MESTIZO' },
    { value: 'INDIGENA' },
    { value: 'NINGUNO' },
]

export const insuranceKind = [
    { value: 'CONTRIBUTIVO' },
    { value: 'ESPECIAL' },
    { value: 'SUBSIDIADO' },
    { value: 'NO APLICA' },
]

export const months = [
    { value: 'ENERO' },
    { value: 'FEBRERO' },
    { value: 'MARZO' },
    { value: 'ABRIL' },
    { value: 'MAYO' },
    { value: 'JUNIO' },
    { value: 'JULIO' },
    { value: 'AGOSTO' },
    { value: 'SEPTIEMBRE' },
    { value: 'OCTUBRE' },
    { value: 'NOVIEMBRE' },
    { value: 'DICIEMBRE' },
]

export const religion = [
    { value: 'ADVENTISTA' },
    { value: 'CATOLICA' },
    { value: 'CRISTIANO' },
    { value: 'EVANGELICO O PROTESTANTE' },
    { value: 'MORMONES' },
    { value: 'SIN INFORMACION' },
    { value: 'NINGUNA' },
]

export const eps = [
    { value: 'AIC', label: 'AIC' },
    { value: 'ASOCIACION SALUD ARS', label: 'ASOCIACION SALUD ARS' },
    { value: 'ALIANSALUD', label: 'ALIANSALUD' },
    { value: 'ASMET SALUD', label: 'ASMET SALUD' },
    { value: 'COMFENALCO', label: 'COMFENALCO' },
    { value: 'COMPENSAR', label: 'COMPENSAR' },
    { value: 'COMFAMILIAR HUILA EPS-CCF', label: 'COMFAMILIAR HUILA EPS-CCF' },
    { value: 'CAFESALUD E.P.S', label: 'CAFESALUD E.P.S' },
    { value: 'COSMITED', label: 'COSMITED' },
    { value: 'COOSALUD', label: 'COOSALUD' },
    { value: 'CRUZ BLANCA EPS', label: 'CRUZ BLANCA EPS' },
    { value: 'EMSANAR', label: 'EMSANAR' },
    { value: 'EPS-SURA', label: 'EPS-SURA' },
    { value: 'FOMAG', label: 'FOMAG' },
    { value: 'FAMIZANAR EPS', label: 'FAMIZANAR EPS' },
    { value: 'FOSYGA', label: 'FOSYGA' },
    { value: 'MALLAMAS', label: 'MALLAMAS' },
    { value: 'MUTUAL', label: 'MUTUAL' },
    { value: 'MEDIMAS', label: 'MEDIMAS' },
    { value: 'NUEVA EPS', label: 'NUEVA EPS' },
    { value: 'SANIDAD MILITAR', label: 'SANIDAD MILITAR' },
    { value: 'SURAMERICANA', label: 'SURAMERICANA' },
    { value: 'SANITAS', label: 'SANITAS' },
    { value: 'S.O.S', label: 'S.O.S' },
    { value: 'SALUD VIDA', label: 'SALUD VIDA' },
    { value: 'SALUD TOTAL', label: 'SALUD TOTAL' },
    { value: 'NINGUNO', label: 'NINGUNO' },
]

export const territories = [
    { value: 1976, label: 'CANOAS' },
    { value: 7601, label: 'CABILDO NASA SANTIAGO DE CALI' },
    { value: 1987, label: 'CERRO TIJERAS' },
    { value: 1983, label: 'CILIA LA CALERA' },
    { value: 1972, label: 'CONCEPCION' },
    { value: 1990, label: 'EL PLAYON NASA NAYA' },
    { value: 1969, label: 'GUADUALITO' },
    { value: 1980, label: 'HUELLAS' },
    { value: 1982, label: 'JAMBALO' },
    { value: 1988, label: 'KITE KIWE' },
    { value: 1977, label: 'LAS DELICIAS' },
    { value: 1915, label: 'LA PAILA' },
    { value: 1971, label: 'LOPEZ ADENTRO' },
    { value: 1974, label: 'MUNCHIQUE LOS TIGRES' },
    { value: 1978, label: 'NASA WALA SINAI ALTO NAYA' },
    { value: 1975, label: 'NASA KIWE TEKH KSXAW' },
    { value: 1970, label: 'PAEZ DE CORINTO' },
    { value: 1979, label: 'PUEBLO NUEVO CERAL' },
    { value: 1985, label: 'SAN FRANCISCO' },
    { value: 1986, label: 'TACUEYO' },
    { value: 1984, label: 'TORIBIO' },
    { value: 1981, label: 'TOEZ' },
    { value: 1991, label: 'WEJXIA KIWE' },
    { value: 1000, label: 'NO APLICA' },
]

export const organization = [
    { value: 'AUTOR ARMADO NO IDENTIFICADO' },
    { value: 'AUTORIDAD INDIGENA' },
    { value: 'COMUNERO INDIGENA' },
    { value: 'COMUNIDAD AFRO' },
    { value: 'COMUNIDAD CAMPESINA' },
    { value: 'COMERCIANTE' },
    { value: 'COMUNIDAD' },
    { value: 'DINAMIZADOR COMUNITARIO' },
    { value: 'EJERCITO' },
    { value: 'FUERZA PUBLICA' },
    { value: 'GRUPO DICIDENCIAS DE LAS FARC' },
    { value: 'GUARDIA INDIGENA' },
    { value: 'INPEC' },
    { value: 'MEDICO TRADICIONAL' },
    { value: 'POLICIA' },
    { value: 'VINCULADO AL NARCOTRAFICO' },
    { value: 'OTROS' },
    { value: 'SIN INFORMACION' },
]

export const relationship = [
    { value: 'ABUELO' },
    { value: 'AMIGO' },
    { value: 'AMIGO DE LA FAMILIA' },
    { value: 'COMPADRE' },
    { value: 'COMUNERO' },
    { value: 'COMPAÑERO DE CLASES' },
    { value: 'COMPAÑERO DE TRABAJO' },
    { value: 'CUÑADO' },
    { value: 'ESPOSO' },
    { value: 'EX PAREJA' },
    { value: 'FAMILIARES' },
    { value: 'HERMANO' },
    { value: 'HIJO' },
    { value: 'MADRE' },
    { value: 'NOVIO' },
    { value: 'NIETO' },
    { value: 'PADRE' },
    { value: 'PAREJA' },
    { value: 'PRIMO' },
    { value: 'PADRASTRO' },
    { value: 'PROFESOR' },
    { value: 'SUEGRO' },
    { value: 'TIO' },
    { value: 'VECINO' },
    { value: 'SIN INFORMACION' },
    { value: 'OTRO' },
]

export const subjet = [
    { value: 'SI' },
    { value: 'NO' },
    { value: 'SIN INFORMACION' },
]

export const reportedTo = [
    { value: 'JUSTICIA ORDINARIA' },
    { value: 'JUSTICIA PROPIA' },
    { value: 'AMBOS' },
]

export const affectationKindIncident = [
    { value: 'SENTIMIENTO DE VENGANZA' },
    { value: 'SIN SUEÑO' },
    { value: 'TEMOR A HABLAR EN PUBLICO' },
    { value: 'TRISTEZA' },
    { value: 'DESINTEGRACION FAMILIAR' },
    { value: 'DISCRIMINACIÓN COLECTIVA' },
    { value: 'DIFICULTADES CON AMIGOS/AS' },
    { value: 'DIFICULTADES CON LA FAMILIA' },
]
